import { useBffApiClient } from "@/shared/hooks/useApiClient";
import { HTTP_STATUS_CODE_NO_CONTENT, HTTP_STATUS_CODE_OK } from "raci-react-library";
import { EnvironmentHealthStatusButton, SystemHealthInformation } from "raci-react-library-npe";
import { useEffect, useState } from "react";

export const EnvironmentHealthStatus: React.FC = () => {
  const initialHealthState: SystemHealthInformation = {};
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [healthStatus, setHealthStatus] = useState(initialHealthState);
  const apiClient = useBffApiClient();

  useEffect(() => {
    let isCancelled = false;

    const getStatus = async () => {
      setIsError(false);
      setIsLoading(true);
      try {
        if (!isCancelled) {
          const response = await apiClient.getHealthStatus();
          if (response.status !== HTTP_STATUS_CODE_OK && response.status !== HTTP_STATUS_CODE_NO_CONTENT) {
            setIsError(true);
          } else {
            if (response.status === HTTP_STATUS_CODE_OK) {
              const healthStatusArray = response.result as SystemHealthInformation;
              setHealthStatus({ ...healthStatusArray });
            }
          }
        }
      } catch {
        setIsError(true);
      } finally {
        setIsLoading(false);
      }
    };

    getStatus();

    return () => {
      isCancelled = true;
    };
  }, [apiClient]);

  return (
    <EnvironmentHealthStatusButton systemHealthInformation={healthStatus} isLoading={isLoading} isError={isError} />
  );
};

export default EnvironmentHealthStatus;
